import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RefundRequest } from '../../../shared/models/request-refund.model';
import { User } from '../../../shared/models/user.model';
import { RefundService } from '../../../shared/services/refund.service';
import { SessionService } from '../../../shared/services/session.service';

@Component({
    selector: 'office-news-consultrefund',
    templateUrl: './consultrefund.component.html'
})
export class ConsultRefundComponent implements OnInit{

    public userItem: User;

    public lista: RefundRequest[] = [];
    public contrato: string;

    constructor(private _sessionService: SessionService
        , private _refundService: RefundService
        , private router: Router) {}

    ngOnInit() {
        this.userItem = this._sessionService.getCurrentUser();
        this.contrato = this._sessionService.getSelectContract();
        this.getReembolsos(this.userItem.user, this.contrato);
    }

    getReembolsos(usuario: string, contrato: string) {
        this._refundService.getReembolsos(usuario, contrato).subscribe(res => {
            this.lista = res;
        });
    }

    irHomeFormatos() {
        this.router.navigate(['/office/refunds/home']);
    }
}


// WEBPACK FOOTER //
// /app/src/app/office/refunds/consult/consultrefund.component.ts